import { useCallback, useState } from 'react';

// Vendor hooks.
import { flushSync } from 'react-dom';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

// Store.
import { constants as appConstants } from 'app/client/store/reducers/app';

/**
 * Drop what the session is scoped to and go to `target`, without reloading the
 * page. `onDone` closes the menu once the call is through.
 */
export default (url, action, target, onDone) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const end = useCallback(async () => {
    setLoading(true);

    try {
      // Awaited, so a failed call cannot leave the store and the session out of sync.
      await axios({ method: 'post', url });
    } catch {
      setLoading(false);
      dispatch({ type: appConstants.setError, payload: 'core:messages.errors.server' });

      return;
    }

    setLoading(false);
    onDone();

    // Own commit, so the customer scoped pages unmount first.
    flushSync(() => dispatch({ type: appConstants.invalidateCustomer }));

    dispatch({ type: action });
    navigate(target);
  }, [dispatch, navigate, url, action, target, onDone]);

  return [end, loading];
};
